import { defineMessages } from "react-intl";

export const productKindMessages = defineMessages({
  giftCardLabel: {
    id: "YKyNm9",
    defaultMessage: "Gift Card",
    description: "label",
  },
  normalLabel: {
    id: "X/K4LI",
    defaultMessage: "Normal",
    description: "label",
  },
});
